<script>
import {http} from "./https";
import { loaded, user } from "./stores";

import Router from "svelte-spa-router";
import {replace} from 'svelte-spa-router';
import { wrap } from "svelte-spa-router/wrap";

import Login from "./routes/Login.svelte";
import Main from "./routes/Main.svelte";
import WidthContext from "./context/WidthContext.svelte";
import ColorContext from "./context/ColorContext.svelte";
import NotificationContext from "./context/NotificationContext.svelte";


export let name = "";

http();

const backToLogin = (e) => {
	replace("/login");
};

const routeEvent = (e) => {
	console.warn("Caught event routeEvent", e.detail);
};

const checkUser = () => {
	return JSON.parse(localStorage.getItem("user")) ? true : false;
};

if ('serviceWorker' in navigator) {
		// Use the window load event to keep the page load performant
		window.addEventListener('load', () => {
			navigator.serviceWorker.register('./service-worker.js');
		});
} else {
		console.log('no service worker capability')
}


const mainRoutes = {
	"/login": Login,
	"/*": wrap({
		component: Main,
		conditions: [
			(detail) => {
				return checkUser();
			},
		],
	}),
};

</script>

<main>

	<WidthContext>
		<ColorContext>
			<NotificationContext>
				<Router routes={mainRoutes} on:conditionsFailed={backToLogin} on:routeEvent={routeEvent} />
			</NotificationContext>
		</ColorContext>
	</WidthContext>
</main>

<style>
		:global(:root) {
		--font-width: 300;

		--button-max-width: 320px;
		--button-height: 40px;

		--input-max-width: 320px;
		--input-height: 40px;
		--svg-fill-color: currentColor;

		--vertical-comp-margin: 10px;
		--z-index-notification: 9;
/* 
		--tabs_nav-height: 50px;
		--tabs_nav-height-mobile: 60px;
		--tabs-top_bor: 2px;
		--tabs_bottom_bor-height: 4px;

		--tabs_consumption_circle: 200px;
		--tabs_consumption_toggler: 30px;
		--tabs_consumption_toggler_margin: 15px;
		--tabs_consumption_titile_padding: 15px;
		--tabs_consumption_titile:20px;
		--tabs_consumption_border:4px;
		--tabs_consumption_list: calc(
      100vh -
        (
          var(--tabs_nav-height) + var(--theme-header_bot_bor) + var(--list_item_scroll_margin) + var(--tabs_consumption_circle) + var(--tabs_consumption_toggler) + var(--tabs_consumption_titile) +
            var(--tabs_consumption_titile) + var(--tabs_consumption_toggler_margin) + var(--tabs_consumption_border)
        )
    ); */

		/* --vertical-comp-margin: 10px;
		--control_button-width-height: 55px;
		--inset-shadow: inset 0px 0px 20px 3px rgba(0, 0, 0, 0.7), inset 0px 0px 20px 3px rgba(0, 0, 0, 0.7);

		--list_item_scroll_margin: 5px;

		--room_layout-header_height: 150px;
		--room_header-top_bor: 2px;

		--device_in_list-height: 60px;
		--device_page-margin: 8px;
		--generic-border: 2px;
		--wrapper-max-width: 500px;

		--svg-fill-color: currentColor;
		--control_button-glow-color: currentColor;

		--z-index-wrapper: 7;
		--z-index-blackout: 8;
		--z-index-notification: 9;
		--header_button-width: 32px;
		--header_button-height: 24px;

		--process_types_height: 40px;
		--process_button_height: 40px;
		--process_list_holder_height: calc(100% - (var(--process_types_height) + var(--process_button_height)));

		--generic_border_radius: 10px; */
	}

	:global(html, body) {
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-tap-highlight-color: transparent;
		min-height: 100%;
		overflow-y: auto;
		user-select: none;
		-webkit-user-select: none; /* Safari */
		-ms-user-select: none; /* IE 10 and IE 11 */
		position: relative;
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
		background-color: var(--color_scheme-background);
		color: var(--color_scheme-text);
		font-size: 16px;
		font-weight: var(--font-width);
		overflow: hidden;
	}

	:global(body) {
		box-sizing: border-box;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	:global(h1, h2, h3, h4, h5, h6, p) {
		margin-block-start: 0;
		margin-block-end: 0;
		font-weight: var(--font-width);
	}

	:global(a) {
		color: currentColor;
		text-decoration: none;
	}

	:global(a:hover) {
		text-decoration: none;
	}

	:global(a:visited) {
		color: currentColor;
	}

	:global(label) {
		display: block;
	}

	:global(input, button, select, textarea) {
		font-family: inherit;
		font-size: inherit;
		color: currentColor;
		caret-color: transparent;
		margin: 0;
		padding: 0;
		outline: none;
		border: none;
		box-sizing: border-box;
		background: none;
		border-radius: 5px;
	}

	:global(button:focus, input:focus) {
		border-color: none;
	}

	:global(button:disabled, button[disabled]) {
		color: grey;
	}

	:global(input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active) {
		box-shadow: 0 0 0 30px var(--color_scheme-background) inset !important;
		-webkit-text-fill-color: var(--color_scheme-text);
	}

	:global(input[type="range"]) {
		height: 0;
	}

	:global(div) {
		-ms-overflow-style: none; /* Internet Explorer 10+ */
		scrollbar-width: none; /* Firefox */
	}

	/* end of clearing styles */

	/* common classes to be used globally -- START */

	:global(.scroll::-webkit-scrollbar) {
		display: none; /* Safari and Chrome */
	}

	:global(.pointer) {
		cursor: pointer;
	}

	:global(.status_icon) {
		display: flex;
		align-self: center;
		width: 20px;
		height: 27px;
		fill: var(--color_scheme-text);
	}

	:global(.font_active) {
		color: var(--color_scheme-contrast_color);
	}
</style>